import React, { useState } from 'react'
import { Tabs } from 'antd'
import TabPane from 'antd/lib/tabs/TabPane'
import CustomModal from 'components/global/CustomModal'
import { eventAttendanceStore } from 'state/event/eventAttendance'
import HistoryTab from '../Common/HistoryTab'
import CheckInOutTab from '../Common/CheckInOutTab'
import DropOutTab from './Content/DropOutTab'

const DropOutModal: React.FC = () => {
  const { dropOutModalOpen, setDropOutModalOpen, setCheckInOutModalOpen } =
    eventAttendanceStore(store => ({
      dropOutModalOpen: store.dropOutModalOpen,
      setDropOutModalOpen: store.setDropOutModalOpen,
      setCheckInOutModalOpen: store.setCheckInOutModalOpen,
    }))
  const [tabKey, setTabKey] = useState<string>('1')

  const closeModal = () => {
    setDropOutModalOpen(false)
    setCheckInOutModalOpen(true)
  }

  return (
    <>
      <CustomModal
        openModal={dropOutModalOpen}
        closeModal={closeModal}
        title="Drop-out"
        width={1200}
        footer={false}
      >
        <Tabs className="" defaultActiveKey={tabKey}>
          <TabPane tab="Drop-out" key="1">
            <DropOutTab />
          </TabPane>
          <TabPane tab="History" key="2">
            <HistoryTab />
          </TabPane>
        </Tabs>
      </CustomModal>
    </>
  )
}

export default DropOutModal
